import React from "react";
import { default as Text } from "/application/webos/webos_tv_emulator/Text";
import { default as List } from "/application/webos/webos_tv_emulator/List";
import { default as Icons } from "/application/webos/webos_tv_emulator/Icons";
import { default as Image } from "/application/webos/webos_tv_emulator/Image";
import { default as Table } from "/application/webos/webos_tv_emulator/Table";
import { default as SingleScreenList } from "/application/webos/webos_tv_emulator/SingleScreenList";
import { default as NumberList } from "/application/webos/webos_tv_emulator/NumberList";
import { default as ScalingImage } from "/application/webos/webos_tv_emulator/ScalingImage";

export default function Body({
  side,
  myJSON,
  emulatorStep,
  setIsSingleStepScreen,
  setSingleScreenStepLength,
  singleScreenStep,
  page,
}) {
  if (side === "left") {
    return (
      <div
        className="info-body"
        style={{
          borderLeft: myJSON.body.border_width
            ? `${myJSON.body.border_width} solid ${myJSON.body.border_color}`
            : null,
          // margin: myJSON.body.margin ? myJSON.body.margin : "0px",
          margin: myJSON.body.margin ? myJSON.body.margin : "0 0 0 0px",
          height: myJSON.body.height ? myJSON.body.height : null,
        }}
      >
        {myJSON.steps &&
        myJSON.steps[emulatorStep] &&
        myJSON.steps[emulatorStep].hide_overlay_content
          ? null
          : myJSON.body.content
          ? myJSON.body.content.map((obj, i) => {
              switch (obj.component) {
                case "text":
                  return <Text key={`body${i}`} content={obj} />;
                case "list":
                  return <List key={`body${i}`} content={obj} />;
                case "icons":
                  return <Icons page={page} key={`body${i}`} content={obj} />;
                case "image":
                  return (
                    <Image
                      key={`body${i}`}
                      content={obj}
                      singleScreenStep={singleScreenStep}
                      page={page}
                    />
                  );
                case "scaling-image":
                  return (
                    <ScalingImage
                      key={`body${i}`}
                      content={obj}
                      singleScreenStep={singleScreenStep}
                    />
                  );
                case "number-list":
                  return <NumberList content={obj} />;
                case "single-screen-list":
                  setIsSingleStepScreen(true);
                  setSingleScreenStepLength(obj.content.length);
                  return (
                    <SingleScreenList
                      key={`body${i}`}
                      content={obj}
                      singleScreenStep={singleScreenStep}
                      setIsSingleStepScreen={setIsSingleStepScreen}
                    />
                  );
                default:
                  return null;
              }
            })
          : null}
      </div>
    );
  } else {
    return (
      <div
        className="right-content"
        style={{
          margin: myJSON.content_data.right_content.margin,
          transformOrigin: myJSON.content_data.right_content.transform_origin
            ? myJSON.content_data.right_content.transform_origin
            : null,
        }}
      >
        {myJSON.content_data.right_content.content &&
          myJSON.content_data.right_content.content.map((obj, i) => {
            switch (obj.component) {
              case "text":
                return <Text key={`rightContent${i}`} content={obj} />;
              case "list":
                return <List key={`rightContent${i}`} content={obj} />;
              case "icons":
                return (
                  <Icons page={page} key={`rightContent${i}`} content={obj} />
                );
              case "image":
                return <Image key={`rightContent${i}`} content={obj} />;
              case "scaling-image":
                return (
                  <ScalingImage
                    key={`body${i}`}
                    content={obj}
                    singleScreenStep={singleScreenStep}
                  />
                );
              case "table":
                return <Table content={obj} />;
              case "number-list":
                return <NumberList content={obj} />;
              // case "single-screen-list":
              // 	setIsSingleStepScreen(true);
              // 	setSingleScreenStepLength(obj.content.length);
              // 	return (
              // 		<SingleScreenList
              // 			content={obj}
              // 			singleScreenStep={singleScreenStep}
              // 			setIsSingleStepScreen={setIsSingleStepScreen}
              // 		/>
              // 	);
              default:
                return null;
            }
          })}
      </div>
    );
  }
}
